// Product description CTA

$("#product-shipping-more-cta").click(function (){
  $('html, body').animate({
    scrollTop: $("#product-info-header-shipping").offset().top - 164
   }, 1500);
});

$("#product-description-full-cta").click(function (){
  $('html, body').animate({
    scrollTop: $("#product-info-header-features").offset().top - 164
   }, 1500);
});

// Product Description Header

$("#product-info-header-features-cta").click(function (){
  $('html, body').animate({
    scrollTop: $("#product-info-header-features").offset().top - 100
   }, 1500);
});

$("#product-info-header-specs-cta").click(function (){
  $('html, body').animate({
    scrollTop: $("#product-info-header-specs").offset().top - 100
   }, 1500);
});

$("#product-info-header-shipping-cta").click(function (){
  $('html, body').animate({
    scrollTop: $("#product-info-header-shipping").offset().top - 100
   }, 1500);
});

$("#product-info-header-des-cta").click(function (){
  $('html, body').animate({
    scrollTop: $("#product-info-header-des").offset().top - 100
   }, 1500);
});

$("#product-info-header-acc-cta").click(function (){
  $('html, body').animate({
    scrollTop: $("#product-info-header-acc").offset().top - 100
   }, 1500);
});

$("#product-info-header-warranty-cta").click(function (){
  $('html, body').animate({
    scrollTop: $("#product-info-header-warranty").offset().top - 100
   }, 1500);
});

$("#product-info-header-reviews-cta").click(function (){
  $('html, body').animate({
    scrollTop: $("#stamped-main-widget").offset().top - 100
   }, 1500);
});

// Header Contact Click
$("#mobile-dropbtn").click(function (){
   $(this).closest(".dropdown-mobile").find('.dropdown-content').slideToggle('slow');
});

$(document).scroll(function() {
  var position = $(this).scrollTop();
  var height = $('.announcement-bar').height();
  if (position > height) {
    $('.breadcrumbs-container-updated').fadeIn("300");
  } else {
    $('.breadcrumbs-container-updated').fadeOut("300");
  }
})

// Product Page: Back to Top
$("#backtoTop").click(function (){
  $('html, body').animate({
    scrollTop: $("#product-page-top").offset().top - 200
   }, 1500);
});

// Product Description 

$(".product-section-container:last-of-type .toggle-body").hide(); 
$(".product-section-container:last-of-type .toggle-button").addClass('active');  
// $(".product-section-container:nth-last-of-type(2) .toggle-body").hide(); 
// $(".product-section-container:nth-last-of-type(2) .toggle-button").addClass('active'); 

$(".toggle-bar").click(function(){
    $(this).closest(".product-section-container").find('.toggle-body').slideToggle('slow');
    $(this).closest(".product-section-container").find('.toggle-button').toggleClass('active');   
 });

$(".toggle-bar").click(function(){
    $(this).closest(".product-accessory--container").find('.toggle-body').slideToggle('slow');
    $(this).closest(".product-accessory--container").find('.toggle-button').toggleClass('active');   
 });


// Time control

var Now = new Date(),
  CurrentDay = Now.getDay(),
  OpeningTime = new Date(Now.getFullYear(), Now.getMonth(), Now.getDate(), 7, 00),
  ClosingTime = new Date(Now.getFullYear(), Now.getMonth(), Now.getDate(), 17, 30),
  Open = (Now.getTime() > OpeningTime.getTime() && Now.getTime() < ClosingTime.getTime());

if (CurrentDay !== 6 && CurrentDay !== 0 && Open) {
    $('.openstatus').toggle();
}

// Product Video Pop-up
function videoPop() {
  document.getElementById("product-video-popup").style.display = "grid";
}

function shippingVideoPop() {
  document.getElementById("product-shipping-video-popup").style.display = "grid";
}

function closeVideo() {
  document.getElementById("product-video-popup").style.display = "none";
  document.getElementById("product-shipping-video-popup").style.display = "none";
}
// Product bf Coupon
function bfPop() {
  document.getElementById("bf-popup").style.display = "grid";
}

function closeBf() {
  document.getElementById("bf-popup").style.display = "none";
}


// Cyber Monday Pop-up
function cyberPop() {
  document.getElementById("cyber-popup").style.display = "grid";
}

function closeCyber() {
  document.getElementById("cyber-popup").style.display = "none";
}

let text06 = document.getElementById('icon-coupon-cyber').innerText;
  const copyCodeC = async () => {
    try {
      await navigator.clipboard.writeText(text06);
      console.log('Content copied to clipboard');
    } catch (err) {
      console.error('Failed to copy: ', err);
    }
  }
// Pickup Policy Pop-up
function pickupPop() {
  document.getElementById("pickup-popup").style.display = "grid";
}

function closePickup() {
  document.getElementById("pickup-popup").style.display = "none";
}

// Pickup Policy Pop-up
function showroompickupPop() {
  document.getElementById("showroom-promo-pickup-popup").style.display = "grid";
}

function closeshowroompickupPop() {
  document.getElementById("showroom-promo-pickup-popup").style.display = "none";
}

// career

